// AI assistant events
export const WEB_AIASSISTANT_USEROPENED = 'WEB_AIASSISTANT_USEROPENED';
export const WEB_AIASSISTANT_USERSENTMESSAGE =
  'WEB_AIASSISTANT_USERSENTMESSAGE';
export const WEB_AIASSISTANT_USEROPENOCUMENTCHAT =
  'WEB_AIASSISTANT_USEROPENOCUMENTCHAT';
export const WEB_AIASSISTANT_NEWCHAT = 'WEB_AIASSISTANT_NEWCHAT';
export const WEB_AIASSISTANT_SEARCHHISTORY = 'WEB_AIASSISTANT_SEARCHHISTORY';
export const WEB_AIASSISTANT_CLICKSUGGESTEDQUESTION =
  'WEB_AIASSISTANT_CLICKSUGGESTEDQUESTION';
export const WEB_AIASSISTANT_CLICKRECORDAUDIO =
  'WEB_AIASSISTANT_CLICKRECORDAUDIO';
export const WEB_AIASSISTANT_CLICKTEXTAREA = 'WEB_AIASSISTANT_CLICKTEXTAREA';
export const WEB_AIASSISTANT_CLICKATTACHMENTS =
  'WEB_AIASSISTANT_CLICKATTACHMENTS';

// AI category guesser events
export const WEB_AICATEGORYGUESSER_CATEGORYGUESSERTRIGGERED =
  'WEB_AICATEGORYGUESSER_CATEGORYGUESSERTRIGGERED';
export const WEB_AICATEGORYGUESSER_USERCHOSECATEGORYFROMCATEGORYGUESSER =
  'WEB_AICATEGORYGUESSER_USERCHOSECATEGORYFROMCATEGORYGUESSER';
export const WEB_AICATEGORYGUESSER_USERCHOSESUGGESTEDCATEGORY =
  'WEB_AICATEGORYGUESSER_USERCHOSESUGGESTEDCATEGORY';

// AI email review events
export const WEB_AIEMAILREVIEW_EMAILREVIEWTRIGGERED =
  'WEB_AIEMAILREVIEW_EMAILREVIEWTRIGGERED';
export const WEB_AIEMAILREVIEW_EMAILREVIEWCONFIRMED =
  'WEB_AIEMAILREVIEW_EMAILREVIEWCONFIRMED';

export const WEB_YEARLYREVIEW_CSATCLICK = 'WEB_YEARLYREVIEW_CSATCLICK';

// AI Consent events
export const WEB_AIASSISTANT_ALLOWALLCONSENTS =
  'WEB_AIASSISTANT_ALLOWALLCONSENTS'; // initial consent: accept all
export const WEB_AIASSISTANT_DENYALLCONSENTS =
  'WEB_AIASSISTANT_DENYALLCONSENTS'; // initial consent: deny all
export const WEB_AIASSISTANT_CHOOSECONSENTS = 'WEB_AIASSISTANT_CHOOSECONSENTS'; // modal: chose what to share

export const WEB_AIASSISTANT_TOOLALLOWTHISTIME =
  'WEB_AIASSISTANT_TOOLALLOWTHISTIME'; // tool consent: allow this time
export const WEB_AIASSISTANT_TOOLDENYTHISTIME =
  'WEB_AIASSISTANT_TOOLDENYTHISTIME'; // tool consent: deny this time

export const WEB_AIASSISTANT_ENABLEAITAXADVISOR =
  'WEB_AIASSISTANT_ENABLEAITAXADVISOR'; // settings: allow AI tax advisor
export const WEB_AIASSISTANT_DISABLEAITAXADVISOR =
  'WEB_AIASSISTANT_DISABLEAITAXADVISOR'; // settings: deny AI tax advisor

export const WEB_AIASSISTANT_UPDATEDCONSENTS =
  'WEB_AIASSISTANT_UPDATEDCONSENTS'; // modal/settings: save + allowed tools list as params
